export const TripType = {
  BOB: "BOB",
  BOX: "BOX",
  INTERCONNECTION: "INTERCONNECTION"
} as const;
export type TripType = (typeof TripType)[keyof typeof TripType];
